import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '79272279-eb86-436a-bf78-af7abf474bef',
	serviceUrl: 'https://api-rel.fundpress.io',
};